/**
 * Уход со страницы — смена пути или параметров: другой документ, другая выборка. Якорь (вкладки карточки, разделы)
 * — не уход. Правило корневой области несохранённых правок (`AppRouter`).
 */
export const leavesPage = (from: URL, to: URL) => from.pathname !== to.pathname || from.search !== to.search;
